import { render, staticRenderFns } from "./BeastHeader.vue?vue&type=template&id=0cf6b780&scoped=true"
import script from "./BeastHeader.vue?vue&type=script&lang=js"
export * from "./BeastHeader.vue?vue&type=script&lang=js"
import style0 from "./BeastHeader.vue?vue&type=style&index=0&id=0cf6b780&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf6b780",
  null
  
)

export default component.exports